import { FieldArrayRenderProps } from "formik";
import { Link,Graph } from "../model/monitoringGraph/types";

const graphDotFormat = (link : Link, numberOfConversations: number, percentage: string) => {
    return `\n ${link.parent} -> ${link.children} [ label =  \"(${link.stats}/${numberOfConversations}) ${percentage}%\"]`
}

const pathDotFormat = (link : Link ) => {
    var regex = /\d+/g
    const parent = link.parent.replace(regex,"")
    const children = link.children.replace(regex,"")
    const parentLabel = `${link.parent} [ label = ${parent}]`
    const childrenLabel = `${link.children} [ label = ${children}]`
    return `${parentLabel} \n ${childrenLabel} \n ${link.parent} -> ${link.children} \n`  
}

export function graphToDot(graphData : Graph, percentageMin : number, percentageMax : number): string {
    var graph = "digraph{"
    graphData.links.forEach(link => {
        const percentage =(link.stats / graphData.numberOfConversations * 100)
        if (percentage >= percentageMin && percentage <= percentageMax){
            graph += graphDotFormat(link,graphData.numberOfConversations,percentage.toFixed(2))
        }
    });
    graph += "}"
    return graph
}

export function pathToDot(links: Link[]): string {
    var path = "digraph{"
    links.forEach(link => {
        path += pathDotFormat(link)
    });
    path += "}"
    return path
}

export const updateEventFormList = (
  eventForm: any,
  eventList : FieldArrayRenderProps,
  event: string
) => {
  if (eventForm.target.checked) {
    eventList.push(event)
  } else {
    const events = eventList.form.values.events
    events.forEach((element : string) => {
      const index = events.indexOf(element)
      if (events[index] === event)
        eventList.remove(index)
    });
  }
}
export const updateActionFormList = (
  event: any,
  actionList: FieldArrayRenderProps,
  action: string
) => {
  if (event.target.checked) {
    const actions = actionList.form.values.actions
    actions.forEach((element: string ) => {
        const index = actions.indexOf(element)
        if (actions[index] === action)
          actionList.remove(index)
    });
  } else {
    actionList.push(action)
  }
}

export const updateList = (
  event: any,
  list: string[],
  action: string
) => {
  if (event.target.checked) {
    list.forEach((element: string) => {
      const index = list.indexOf(element)
      if (list[index] === action) list.splice(index,1)
    });
  } else {
    list.push(action)
  }
}
